import { render, staticRenderFns } from "./BoxSection.vue?vue&type=template&id=700cc9ae&scoped=true"
import script from "./BoxSection.vue?vue&type=script&lang=js"
export * from "./BoxSection.vue?vue&type=script&lang=js"
import style0 from "./BoxSection.vue?vue&type=style&index=0&id=700cc9ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700cc9ae",
  null
  
)

export default component.exports